import { Descriptions } from "@/components/v2";
import { type DescriptionsProps } from "antd";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { formatDateTime } from "@/lib/helpers/format";
import { Card } from "@rumbledirect/ui";

interface AppointmentsCardProps {
  dossier?: Dossier;
  isLoading: boolean;
}

export const AppointmentsCard = ({
  dossier,
  isLoading,
}: AppointmentsCardProps) => {
  // Checks if the dossier has any planned appointment time slots.
  const dossierHasAppointmentTimeSlotPlanned = (dossier?: Dossier) => {
    if (
      !dossier ||
      !dossier.appointmentTimeSlotsPlanned ||
      dossier.appointmentTimeSlotsPlanned.length === 0
    ) {
      return false;
    }
    return true;
  };

  // Checks if the dossier has any appointment time slots.
  const dossierHasAppointmentTimeSlots = (dossier?: Dossier) => {
    if (
      !dossier ||
      !dossier.appointmentTimeSlots ||
      dossier.appointmentTimeSlots.length === 0
    ) {
      return false;
    }
    return true;
  };

  if (
    !dossierHasAppointmentTimeSlotPlanned(dossier) &&
    !dossierHasAppointmentTimeSlots(dossier)
  )
    return null;

  const items: DescriptionsProps["items"] = [];

  // Show planned appointment (first one)
  if (dossierHasAppointmentTimeSlotPlanned(dossier)) {
    items.push({
      key: "planned",
      label: "Afspraak datum (gepland)",
      children: formatDateTime(dossier!.appointmentTimeSlotsPlanned[0].start),
    });
  }

  // Show all appointment time slots
  if (dossierHasAppointmentTimeSlots(dossier)) {
    dossier!.appointmentTimeSlots.forEach((slot, idx) => {
      items.push({
        key: `slot-${slot.id ?? idx}`,
        label: `Afspraak datum ${idx + 1}`,
        children: formatDateTime(slot.start),
      });
    });
  }

  return (
    <Card loading={isLoading} className="w-full" title="Afspraak">
      <Descriptions items={items} />
    </Card>
  );
};
